import { ContentPageLayout } from "@components/content-page/layout"
import { PricingPageFaq } from "@components/_pricing-page/Faq"
import { PricingPageHero } from "@components/_pricing-page/Hero"
import { getDrafts, getSanityClient } from "@lib/sanity"
import { getFooterFromSanity } from "@lib/sanity/helpers/get-footer-from-sanity"
import { GetStaticProps, NextPage } from "next"
import {
  FaqQuestion,
  FooterSingleton,
  PricingSingleton,
} from "__generated__/sanity"

type Questions = {
  questions: FaqQuestion[]
}
type Content = PricingSingleton & {
  categories: Questions[]
}
type PricingPageProps = {
  content: Content
  footer: FooterSingleton
}

const PricingPage: NextPage<PricingPageProps> = ({ content, footer }) => {
  const questions = mergeQuestions(content.categories)

  return (
    <ContentPageLayout footer={footer} seo={content.fields.seo}>
      <PricingPageHero {...content.fields.hero} />
      <PricingPageFaq {...content.fields.faq} questions={questions} />
    </ContentPageLayout>
  )
}

function mergeQuestions(categories: Questions[]) {
  return categories.reduce((acc, category) => {
    return [...acc, ...category.questions]
  }, [])
}

export default PricingPage

export const getStaticProps: GetStaticProps = async ({ preview }) => {
  const sanity = getSanityClient(preview)
  const footer = await getFooterFromSanity(preview)

  const pricingContent = await sanity.fetch(`*[_type == "pricing-singleton"] {
    ...,
    "categories": fields.faq.faqCategories[]->{
      "questions": fields.questions[]->{
        ...
      },
    },
  }`)

  return {
    props: {
      content: getDrafts(pricingContent)[0],
      footer,
    },
  }
}
